<template>
  <section class="section job-offer__section w-95" :id="HASHES.AVAILABLE_POSITIONS">
    <div class="job-offer__panel">
      <div>
        <h2 class="title --uppercase" v-reveal>{{ content.title.replace('[COUNT]', this.filteredOffers.length) }}</h2>
        <LangRouterLink :to="{name: ROUTES.HOME, hash: `#${HASHES.AVAILABLE_POSITIONS}`}" class="job-offer__clear">
          {{ content.filtersClear }}
        </LangRouterLink>
        <JobOfferFilters :title="content.filtersType" type="FIELD_TYPE" v-reveal/>
        <JobOfferFilters :title="content.filtersLocation" type="LOCATION" v-reveal/>
        <JobOfferFilters :title="content.filtersCompany" type="COMPANY" v-reveal/>
      </div>
      <div class="job-offer__panel-bottom" v-reveal>
        <p class="description">{{ content.empty }}</p>
        <div class="job-offer__panel-buttons">
          <InternalLink :content="{link: getFormLink('job_alert'), label: content.alert}" button
                        secondary full/>
          <a :href="`mailto:${$beet.options.contact.email}`" target="_blank" class="button --full">{{ content.spontaneous }}</a>
        </div>
      </div>
    </div>
    <div class="job-offer__list" ref="list">
      <h3 class="title --small job-offer__no-result" v-if="this.filteredOffers.length <= 0">{{ $t('noResults') }}</h3>
      <JobOfferCard v-for="offer in paginatedOffers" :key="offer.id" :content="offer"/>
      <JobOfferPagination :offers-length="filteredOffers.length" :pagination-size="paginationSize"
                          :current-page="currentPage" @navigate="newPage => currentPage =  newPage"/>
    </div>
  </section>
</template>

<script>
import {JobOfferFilters, JobOfferPagination} from '@/components/blocks'
import {JobOfferCard} from '@/components/cards'
import {LangRouterLink} from '@/components/global'
import {InternalLink} from '@/components/small'
import {HasContentMixin, UsesRoutesMixin} from '@/mixins'

export default {
  name: 'AvailablePositionsSection',
  mixins: [HasContentMixin, UsesRoutesMixin],
  components: {JobOfferCard, JobOfferFilters, JobOfferPagination, InternalLink, LangRouterLink},
  data() {
    return {
      currentPage: 0,
      paginationSize: 10
    }
  },
  computed: {
    filteredOffers() {
      let offers = [...this.$store.state.job.offers]

      if (this.$route.query) {
        if (this.$route.query.l?.length) {
          const filters = this.$route.query.l instanceof Array ? this.$route.query.l : [this.$route.query.l]

          offers = offers.filter(({location}) => filters.includes(location.toString()))
        }

        if (this.$route.query.t?.length) {
          const filters = this.$route.query.t instanceof Array ? this.$route.query.t : [this.$route.query.t]

          offers = offers.filter(({type}) => filters.includes(type.toString()))
        }

        if (this.$route.query.c?.length) {
          const filters = this.$route.query.c instanceof Array ? this.$route.query.c : [this.$route.query.c]

          offers = offers.filter(({company}) => filters.includes(company.toString()))
        }
      }

      return offers
    },
    paginatedOffers() {
      let pageIndex = this.currentPage * this.paginationSize
      if (pageIndex > 0) pageIndex -= 1
      return this.filteredOffers.slice(pageIndex, pageIndex + this.paginationSize)
    }
  },
  methods: {
    getFormLink(formKey) {
      const query = {}
      query[this.QUERY_KEYS['FORM']] = formKey

      return {name: this.ROUTES.HOME, query: query}
    }
  },
  watch: {
    'currentPage'() {
      window.scrollTo({behavior: 'smooth', top: this.$refs.list.offsetTop})
    },
    '$route'() {
      this.currentPage = 0
    }
  }
}
</script>